// removed by extract-text-webpack-plugin
module.exports = {"content":"_3wAlwCkZgN2l-P9Aiab0Ni","deferText":"_3ng3TZwAwUVQ4GHq2ZxX2l","postpone":"_1-MTzCqxISbZ2SQkTDGvub","postponeLine":"_2YPRtcMruaHeN_jelkA42i","datapicker":"_3N6AoCvC0cok18ncrgXPle"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/BundleView/index.less
// module id = 403
// module chunks = 0